import { network } from 'services/network';

export const mapToContract = (params) => {
    return network.post('api/bo/phaseperformance/mapToContract', params).then((response) => {
        return response.data;
    });
};
